import { get } from 'lodash';
import { Brand, Environment } from '@lendi/lala-react';

import bridge from './bridge';
import { datadogUtil } from './datadogRum';

export const LENDI_CUSTOMER_PREFIX = '/home-loans';
export const AUSSIE_CUSTOMER_PREFIX = '/home-loans';

export const LENDI_CUSTOMER_BASE_URL = `${LENDI_CUSTOMER_PREFIX}/basics`;
export const AUSSIE_CUSTOMER_BASE_URL = `${AUSSIE_CUSTOMER_PREFIX}/basics`;

const LENDI_AUTH_BASE_URL_OLD = '/sign-in';
const AUSSIE_AUTH_BASE_URL_OLD = '/sign-in';

const LENDI_AUTH_BASE_URL_NEW = '/sign-in/sign-up';
const AUSSIE_AUTH_BASE_URL_NEW = '/sign-in/sign-up';

const LENDI_HOMEPAGE_URL = '/';
const AUSSIE_HOMEPAGE_URL = '/';

const CvDomainMap: Record<Brand, Record<Environment, string>> = {
  lendi: {
    development: 'https://www.lendi-dev.net',
    staging: 'https://www.lendi-stg.net',
    preproduction: 'https://www.lendi-preprod.net',
    production: 'https://www.lendi.com.au',
  },
  aussie: {
    development: 'https://www.aussie-dev.com.au',
    staging: 'https://www.aussie-stg.com.au',
    preproduction: 'https://www.aussie-preprod.com.au',
    production: 'https://www.aussie.com.au',
  },
};

export function getBrand(): Brand {
  let brand = Brand.Lendi;

  try {
    const localStorageVendor = get(window, 'localStorage.vendor', '');
    brand = (localStorageVendor || bridge.vendor).toLowerCase();
  } catch (error) {
    datadogUtil.addError(error);
  }
  return brand;
}

export function getBrandSpecificValue<T = string>(obj: { [K in Brand]: T }): T {
  return obj[getBrand()];
}

export function getBrandSpecificHomepageURL(): string {
  return getBrandSpecificValue({
    lendi: LENDI_HOMEPAGE_URL,
    aussie: AUSSIE_HOMEPAGE_URL,
  });
}

export function getBrandSpecificURLPrefix(): string {
  return getBrandSpecificValue({
    lendi: LENDI_CUSTOMER_PREFIX,
    aussie: AUSSIE_CUSTOMER_PREFIX,
  });
}

export function getBrandSpecificBaseURL(): string {
  return getBrandSpecificValue({
    lendi: LENDI_CUSTOMER_BASE_URL,
    aussie: AUSSIE_CUSTOMER_BASE_URL,
  });
}

export function getBrandSpecificAuthURL(isNew: boolean = false): string {
  if (isNew) {
    return getBrandSpecificValue({
      lendi: LENDI_AUTH_BASE_URL_NEW,
      aussie: AUSSIE_AUTH_BASE_URL_NEW,
    });
  }

  return getBrandSpecificValue({
    lendi: LENDI_AUTH_BASE_URL_OLD,
    aussie: AUSSIE_AUTH_BASE_URL_OLD,
  });
}

export function getBrandSpecificDashboardBaseURL(): string {
  return getBrandSpecificValue({
    lendi: '',
    aussie: '',
  });
}

export function getCvBrandSpecificBaseDomain(brand: Brand, environment: Environment): string {
  return CvDomainMap[brand][environment];
}
